<template>
  <div class="location-info container text-left" v-if="data">
    <div class="row border-bottom">
      <h3 class="col-12">{{data.title.rendered}}</h3>
    </div>
    <div class="row">
      <p class="col-12" v-html="data.content.rendered"></p>
    </div>
    <dl class="row text-left">
      <template v-if="data.data.address">
        <dt class="col-sm-3">所在地</dt>
        <dd class="col-sm-9">{{data.data.address}}</dd>
      </template>
      <template v-if="data.data.tel">
        <dt class="col-sm-3">連絡先</dt>
        <dd class="col-sm-9">{{data.data.tel}}</dd>
      </template>
      <template v-if="data.data.open_times">
        <dt class="col-sm-3">営業時間</dt>
        <dd class="col-sm-9">{{data.data.open_times}}</dd>
      </template>
      <template v-if="data.data.closing_days">
        <dt class="col-sm-3">休日</dt>
        <dd class="col-sm-9">{{data.data.closing_days}}</dd>
      </template>
      <template v-if="data.data.site">
        <dt class="col-sm-3">ホームページ</dt>
        <dd class="col-sm-9">
          <a :href="data.data.site" target="_blank">{{data.data.site}}</a>
        </dd>
      </template>
      <template v-if="data.data.description">
        <dt class="col-sm-3">備考</dt>
        <dd class="col-sm-9">{{data.data.description}}</dd>
      </template>
    </dl>

    <div class="row mt-5" v-if="mapInfo && mapInfo.markers">
      <div class="col-12 map-container">
        <map-view :center="mapInfo.center" :zoom="mapInfo.scale" :markers="mapInfo.markers"/>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
import MapView from "@/components/MapView";
export default {
  props: {
    data: Object
  },
  data() {
    return {};
  },
  components: {
    MapView
  },
  computed: {
    mapInfo() {
      if (!this.data.data.map_url) {
        return null;
      }

      const v = utils.convertMapUrlToLatLang(this.data.data.map_url);
      return v;
    }
  }
};
</script>

<style lang="scss">
.location-info {
  .map-container {
    height: 400px;
    .map {
      height: 350px;
    }
  }
}
</style>
